import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { getBoardMembers } from '../services/boardMemberService'
import type { BoardMember } from '../types'

const BoardMembersPage = () => {
  const [boardMembers, setBoardMembers] = useState<BoardMember[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const data = await getBoardMembers()
        setBoardMembers(data)
      } catch (error) {
        console.error('Failed to fetch board members:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchMembers()
  }, [])

  const breadcrumbs = [
    { label: 'ホーム', to: '/' },
    { label: '理事紹介' },
  ]

  if (loading) {
    return (
      <>
        <Header breadcrumbs={breadcrumbs} />
        <main>
          <div className="container" style={{ padding: '4rem 0', textAlign: 'center' }}>
            <p>読み込み中...</p>
          </div>
        </main>
        <Footer />
      </>
    )
  }

  return (
    <>
      <Header breadcrumbs={breadcrumbs} />
      <main>
        <section className="board-hero" aria-labelledby="board-hero-heading">
          <div className="container">
            <p className="section-pretitle">BOARD MEMBERS</p>
            <h1 id="board-hero-heading" className="board-hero-title">
              理事紹介
            </h1>
            <p className="board-hero-lead">
              技術・ビジネス・財務の三位一体による運営体制で、ITプロフェッショナルが安心して活躍できる環境を整えます。
              現場主義を貫き、誠実で高い技術を持つ人材が正しく評価される仕組みづくりを推進します。
            </p>
            <div className="board-hero-meta" aria-label="理事構成">
              <div>
                <span className="board-hero-number">6</span>
                <span className="board-hero-label">理事</span>
              </div>
              <div>
                <span className="board-hero-number">1</span>
                <span className="board-hero-label">監事</span>
              </div>
              {/* <div>
                <span className="board-hero-number">3</span>
                <span className="board-hero-label">専門領域（技術・ビジネス・財務）</span>
              </div> */}
            </div>
          </div>
        </section>

        <section className="board-members" aria-label="理事一覧">
          <div className="container">
            {boardMembers.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#666', padding: '2rem 0' }}>
                現在理事情報を準備中です
              </p>
            ) : (
            <div className="board-grid">
              {boardMembers.map((member) => (
                <article className="board-card" key={member.id}>
                  <div className="board-card-image">
                    <img src={member.image} alt={`${member.name}の写真`} loading="lazy" />
                  </div>
                  <div className="board-card-body">
                    <p className="board-card-name-en">{member.nameEn}</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem',
                        marginBottom: '0.25rem',
                      }}
                    >
                      <h3 className="board-card-name" style={{ marginBottom: 0 }}>
                        {member.name}
                      </h3>
                      {member.linkedinUrl && (
                        <a
                          href={member.linkedinUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`${member.name}のLinkedInプロフィール`}
                          style={{
                            color: '#0A66C2',
                            display: 'flex',
                            alignItems: 'center',
                            transition: 'opacity 0.2s',
                            outline: 'none',
                          }}
                          onMouseOver={(e) => (e.currentTarget.style.opacity = '0.8')}
                          onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                          </svg>
                        </a>
                      )}
                    </div>
                    <p className="board-card-title">{member.title}</p>
                    <p className="board-card-company">{member.company}</p>
                    <p className="board-card-description">{member.description}</p>
                    <ul className="board-card-tags">
                      {member.focusAreas.map((area) => (
                        <li key={area}>{area}</li>
                      ))}
                    </ul>
                  </div>
                </article>
              ))}
            </div>
            )}
          </div>
        </section>

        <section className="board-cta">
          <div className="container board-cta-inner">
            <div>
              <h2>共に未来を創る仲間を募集しています</h2>
              <p>
                誠実なITビジネス・プロフェッショナルが正しく評価される仕組みを共に築き、
                若手からベテランまで、安心して長く活躍できる環境を広げていきませんか。
                顧客成功を支える「信用のインフラ」を共に整え、日本社会のDX/AX推進に貢献する仲間を募集しています。
              </p>
            </div>
            <Link to="/#contact" className="btn btn-primary">
              お問い合わせへ
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default BoardMembersPage


